import {AfterContentInit, Component, EventEmitter, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, of, Subscription}                         from 'rxjs';
import {ApGridPagerType, ApStatsType, IGridPagerData, MapViewMode}                            from '../../ap-interface';
import {ApPermissions}                                                                        from 'invoker-transport';
import {
  ApDynComponentComponent
}                                                                                             from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynGridPagerConfig,
  IDynGridWizardChoiceData
}                                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridEditColumnConfig
}                                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {GetRoundNumericPipe}                                                                  from '../../ap-utils';
import {Validators}                                                                           from '@angular/forms';
import {
  IModalDialogResult
}                                                                                             from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  CropTypeStore
}                                                                                             from '../../stores/base-data/crop.types.store';
import {
  SettingsStore
}                                                                                             from '../../stores/base-data/settings.store';
import {
  FieldStore
}                                                                                             from '../../stores/farm/field.store';
import {filter, map, skip}                                                                    from 'rxjs/operators';
import {
  StatisticStore
}                                                                                             from '../../stores/statistic/statistic.store';
import {
  FormStore
}                                                                                             from '../../stores/layout/form.store';
import {
  MapViewStore
}                                                                                             from '../../stores/layout/mapview.store';
import {
  ModalDialogStore
}                                                                                             from '../../stores/dialog/modal.dialog.store';
import {
  TranslationStore
}                                                                                             from '../../stores/translation/translation.store';
import {
  MapStore
}                                                                                             from '../../stores/map/map.store';
import {
  GetPermissionPipe
}                                                                                             from '../../ap-permission/pipes/get-permission.pipe';
import {
  ParameterDefinitionStore
}                                                                                             from '../../stores/parameter/parameter.definition.store';
import {
  GetRoundNumericService
}                                                                                             from '../../ap-utils/service/get-round-numeric.service';
import {
  CampaignYearStore
}                                                                                             from '../../stores/login/campaignyear.store';
import {
  LoginStore
}                                                                                             from '../../stores/login/login.store';
import {
  ParameterValuesStore
}                                                                                             from '../../stores/parameter/parameter.values.store';
import {
  ApDynformsConfigFieldset
}                                                                                             from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsValidator
}                                                                                             from '../../ap-dynforms/ap-dynforms-validator';
import {
  ApDynformsConfigComboBox
}                                                                                             from '../../ap-dynforms/config/ap-dynforms-config-combobox';
import {
  ApDynformsConfigNumerictextbox
}                                                                                             from '../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsConfigCheckbox
}                                                                                             from '../../ap-dynforms/config/ap-dynforms-config-checkbox';
import {
  ApDynformsConfigPlaceholder
}                                                                                             from '../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {Create, ObjectFactory}                                                                from 'ts-tooling';
import {
  ApGetCropService
}                                                                                             from '../../stores/services/ap-get-crop.service';
import {
  ModalDialogPresets
}                                                                                             from '../../stores/dialog/modal.dialog.presets';
import {
  ApUtilService
}                                                                                             from '../../ap-utils/service/ap-util.service';
import {
  ApDynGridStatusColumnConfig
}                                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  JobsStore
}                                                                                             from '../../stores/administration/jobs.store';
import * as download                                                                          from 'downloadjs';
import {
  MapFactoryRequestor
}                                                                                             from '../../map-factory/map-factory-requestor';
import {
  ApGetCropStatisticService
}                                                                                             from '../../stores/services/ap-get-crop-statistic.service';
import {
  ApEditFieldComponent
}                                                                                             from '../../entry-components/ap-field-management-entry-components/ap-edit-field.component';
import {
  LanguageStore
}                                                                                             from '../../stores/translation/language.store';
import {
  ApDateService
}                                                                                             from '../../ap-core/services/ap-date-service';
import {
  ApMergeFieldComponent,
  MergeNewFieldName
}                                                                                             from '../../entry-components/ap-field-management-entry-components/ap-merge-field.component';
import {
  FieldFactoryService
}                                                                                             from '../../factories/field-factory.service';
import {
  FieldGridDataFactoryService,
  IFieldGridData
}                                                                                             from '../../factories/field-grid-data-factory.service';
import {
  NotifyStore
}                                                                                             from '../../stores/dialog/notify.store';
import {
  ApSplitFieldComponent,
  SplitFieldData
}                                                                                             from '../../entry-components/ap-field-management-entry-components/ap-split-field.component';
import {FieldService}                                                                         from './field.service';
import {
  ApRoleTypeService
}                                                                                             from '../../services/common/ap-role-type.service';
import {
  ApDynGridGroupColumnConfig
}                                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApTooltipContentService
}                                                                                             from '../../ap-utils/service/ap-tooltip-content.service';
import {
  StatisticService
}                                                                                             from '../../services/data/statistic.service';
import {
  GetRoundNumericPipeConfig
}                                                                                             from '../../ap-utils/pipes/configs/get-round-numeric.pipe.config';
import IParameterValue = Data.Parameter.IParameterValue;
import IField = Data.FieldManagement.IField;
import ParameterType = Data.Parameter.Enums.ParameterType;
import IFieldCrop = Data.FieldManagement.IFieldCrop;
import IGuid = System.IGuid;
import IApValidationResult = Data.Api.Validation.IApValidationResult;
import ApValidationLevel = Data.Api.Validation.ApValidationLevel;

export enum FieldMassEditAction {
  EditMainCrop = 0,
  EditSecondCrop = 1,
  ResetMainCrop = 2,
  ResetSecondCrop = 3,
  MergeFields = 4,
  UpdateCropNote = 5,
  DeleteFields = 6
}

type PreviousCurrentValue = {
  PreviousValue: number;
  CurrentValue: number
};

/**
 * Component for the field overview
 */
@Component({
  selector: 'ap-field-overview',
  template: `
    <ap-dyncomponent [caption]="'Admin_Pages__Overview'"
                     [canSearch]="true"
                     [canCreate]="(ApPermissions.EDIT_FIELDS | getPermission | async) && campaignYearStore.IsHighestCampaignYear"
                     [headerIcon]="'ap-icon-fields'"
                     [filterTooltip]="'filterTooltip'"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [loading$]="fieldsLoadingOrSaving$"
                     [pager]="pager$ | async"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
                     (edit)="onEdit($event)"
                     (create)="onCreate()">
    </ap-dyncomponent>
    <ng-template #ComboBoxCropTypeItem let-Description="Description">
      <span>{{ Description }}</span>
    </ng-template>
  `
})
export class FieldOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  @ViewChild('ComboBoxCropTypeItem', {static: true}) comboBoxCropTypeItem: TemplateRef<any>;
  public readonly ValueNotSet: number = undefined;

  public fieldsLoadingOrSaving$ = of(false);
  public items$: Observable<IFieldGridData[]> = of([]);
  public columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  public pager$: Observable<ApDynGridPagerConfigBase>;
  public filter: string;
  public caption: string;
  public ApPermissions = ApPermissions;

  private _currentMultiSelectFormValue = {};
  private _subscriptions: Array<Subscription> = [];
  private _onSelectionChanged: Subscription;
  private _deleteFieldIds: any;
  private _checkForRelatedDataOnDelete = false;
  private _applyClickedEvent = new EventEmitter<any>();
  private _onEditEvent = new EventEmitter<IFieldGridData>();
  private _onSplitEvent = new EventEmitter<IFieldGridData>();
  private _onDeleteEvent = new EventEmitter<IFieldGridData>();
  private _onDownloadPackageEvent = new EventEmitter<IFieldGridData>();
  private _mainCropId$ = new BehaviorSubject<number>(undefined);
  private _secondCropId$ = new BehaviorSubject<number>(undefined);
  private _mainCropMassEditChanged$ = new BehaviorSubject<PreviousCurrentValue>(undefined);
  private _secondCropMassEditChanged$ = new BehaviorSubject<PreviousCurrentValue>(undefined);
  private _massEditPagerData: IGridPagerData;

  constructor(private fieldStore: FieldStore,
              private fieldService: FieldService,
              public campaignYearStore: CampaignYearStore,
              private formStore: FormStore,
              private cropTypeStore: CropTypeStore,
              private permissionPipe: GetPermissionPipe,
              private mapViewStore: MapViewStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private roundNumericService: GetRoundNumericService,
              private settingsStore: SettingsStore,
              private mapStore: MapStore,
              private loginStore: LoginStore,
              private languageStore: LanguageStore,
              private translationStore: TranslationStore,
              private statisticStore: StatisticStore,
              private modalDialogPresets: ModalDialogPresets,
              private modalDialogStore: ModalDialogStore,
              private getCropService: ApGetCropService,
              private cropStatistic: ApGetCropStatisticService,
              private parameterDefinitionStore: ParameterDefinitionStore,
              private parameterValueStore: ParameterValuesStore,
              private dateService: ApDateService,
              private jobStore: JobsStore,
              private statisticService: StatisticService,
              private fieldFactory: FieldFactoryService,
              private fieldGridDataFactory: FieldGridDataFactoryService,
              private tooltipContentService: ApTooltipContentService,
              private notifyStore: NotifyStore) {
  }

  public ngOnInit(): void {
    this.mapViewStore.goIntoMapMenuSync();
    this.fieldsLoadingOrSaving$ = combineLatest([
      this.fieldStore.Listen(s => s.loading),
      this.fieldStore.Listen(s => s.saving)
    ]).pipe(
      map(([loading, saving]) => loading || saving)
    );
    this._gridBuilder();
    this._onSelectionChanged = this.dynComponent.SelectedItems$.subscribe(d => this._selectionChange(d));
    this.items$ = this._getItems();
  }

  public ngAfterContentInit(): void {
    this.mapStore.Editor.ClearMergeFieldResult();
    this._subscriptions.push(this._applyClickedEvent.subscribe((e) => this._onApplyClicked(e)));
    this._subscriptions.push(this.fieldStore.Listen(s => s.saved).subscribe(saved => this._onFiledStoreSaved(saved)));
    this._subscriptions.push(this.fieldStore.Listen(s => s.fieldCropsSaved).subscribe(saved => this._fieldCropSaved(saved)));
    this._subscriptions.push(this._onEditEvent.subscribe((e: IFieldGridData) => this.onEdit(e)));
    this._subscriptions.push(this._onSplitEvent.subscribe((e: IFieldGridData) => this._onSplit(e)));
    this._subscriptions.push(this._onDeleteEvent.subscribe((e: IFieldGridData) => this._openDeleteDialog([e])));
    this._subscriptions.push(this._onDownloadPackageEvent.subscribe((e: IFieldGridData) => this._onDownloadPackageId(e.PackageId)));
    this._subscriptions.push(this.mapStore.Listen(x => x.mergeFieldResult).subscribe((mergeResult) => this._onMerge(mergeResult)));
    this._subscriptions.push(this.dynComponent.gridInitialized.subscribe((): void => {
      this._subscriptions.push(this.dynComponent.dynGrid.gridPager.gridMultiSelect.formValueChanges.subscribe(v => this._onFormValuesChange(v)));
    }));
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe((items: any[]): void => this._onSelectedItems(items)));
    this._subscriptions.push(this.formStore.FormClose$.subscribe(() => this.mapStore.Editor.CloseEditor(this.fieldStore)));
    this._subscriptions.push(this.modalDialogStore.Listen(s => s.result).pipe(skip(1)).subscribe(c => {
      this._modalDialogOkClicked(c);
    }));
    this._subscriptions.push(this._prepareRelatedDataCheckDialog());
  }

  private _prepareRelatedDataCheckDialog(): Subscription {
    return this.fieldStore.Listen(s => s.fieldRelatedDataResult).subscribe(planBooks => {
      if (planBooks != null) {
        if (this._checkForRelatedDataOnDelete) {
          if (planBooks === true) {
            this.modalDialogStore.setModalDialogData(this.modalDialogPresets.ExistRelatedDataDialog(
              {confirmKey: 'confirmFieldOverview'})
            );
          } else {
            this.fieldStore.deleteFields(this._deleteFieldIds);
          }
        }
        this._checkForRelatedDataOnDelete = false;
        this.fieldStore.clearFieldRelatedDataResult();
      }
    });
  }

  public ngOnDestroy(): void {
    this.statisticStore.removeStatisticData();
    this._subscriptions.forEach(d => d.unsubscribe());
    this._onSelectionChanged?.unsubscribe();
  }

  private _onSelectedItems(items: any[]): void {
    const selectedCrops: IFieldCrop[] = items.map((item: IFieldGridData) => item.SourceItem.FieldCrops.Find((crop) => this.campaignYearStore.isSelectedCampaignYear(crop)));
    if (selectedCrops.length !== 0 && selectedCrops.every((v, _, a) => !!v && !!a[0] && v.CroptypeId === a[0].CroptypeId)) {
      this._mainCropId$.next(selectedCrops[0].CroptypeId);
    } else {
      this._mainCropId$.next(undefined);
    }
    if (selectedCrops.length !== 0 && selectedCrops.every((v, _, a) => !!v && !!a[0] && v.CroptypeSecondId === a[0].CroptypeSecondId)) {
      this._secondCropId$.next(selectedCrops[0].CroptypeSecondId);
    } else {
      this._secondCropId$.next(undefined);
    }
  }

  private _onFormValuesChange(controlValue: { control: string, value: any }): void {
    const previousValue = this._currentMultiSelectFormValue[controlValue.control];
    this._currentMultiSelectFormValue[controlValue.control] = controlValue.value;
    if (controlValue.control === 'MainCrop') {
      this._mainCropMassEditChanged$.next({PreviousValue: previousValue, CurrentValue: controlValue.value});
    }
    if (controlValue.control === 'SecondCrop') {
      this._secondCropMassEditChanged$.next({PreviousValue: previousValue, CurrentValue: controlValue.value});
    }
  }

  private _getItems(): Observable<IFieldGridData[]> {
    return this.fieldStore.Fields$.pipe(
      filter(fields => !!fields),
      map(fields => {
        return fields.map(field => {
          const selectedCampaignYear = this.campaignYearStore.SelectedCampaignYear;
          const geom = this.fieldStore.getCurrentFieldGeom(field);
          const adminArea = Create(geom?.AdminArea, 0);
          const area = adminArea > 0 ? adminArea / 10000 : '-';
          const status = this.fieldService.getGeomStatus(geom, selectedCampaignYear);
          const pack = geom?.FieldGeomPackages?.Find(_ => _?.Year === selectedCampaignYear.Year);
          const mainCrop = this.getCropService.parseMainCrop(field);
          const fieldCrop = mainCrop ? this.getCropService.getFieldCrop(field) : null;
          return {
            Id: field.Id,
            Status: status,
            StatusClass: status === 1 ? 'ap-status-green' : 'ap-status-red',
            StatusDesc: '',
            SourceItem: field,
            Geom: geom,
            Note: fieldCrop?.Note,
            NrSNr: this.fieldStore.getFieldNumberAndSubNumber(field),
            LandUse: '', // Not yet available. Maybe in future we'll take it from wsv_raster_meta_data
            Area: area === '-' ? undefined : this.roundNumericService.roundAsNumber(area, this.settingsStore.FirstSetting.DigitsAfterDecimalPoint),
            AreaOriginal: area === '-' ? undefined : area.toString(10),
            MainCrop: mainCrop,
            SecondCrop: this.getCropService.parseSecondCrop(field),
            CropData: fieldCrop,
            MainCropExpectedYield: this.getCropService.parseMainCropExpectedYield(field),
            SecondCropExpectedYield: this.getCropService.parseSecondCropExpectedYield(field),
            StrawHarvested: this.getCropService.parseStrawHarvested(field),
            PackageId: pack?.PackageId,
            Creation: geom?.CreatedAt ? this.dateService.toFarmDateFromUtcGetJsDate(geom?.CreatedAt, this.languageStore.IsoDateTimeFormat) : null,
          } as IFieldGridData;
        });
      })
    );
  }

  private _selectionChange(selectedItems: IFieldGridData[]): void {
    if (this.dynComponent.items?.length <= 0 && selectedItems?.length <= 0) {
      return;
    }
    let itemsToSelect: IFieldGridData[] = selectedItems;
    if (itemsToSelect && itemsToSelect.length > 0) {
      this.fieldStore.changeSelectedField(itemsToSelect.map(x => x.Id?.toString()));
    } else {
      itemsToSelect = this.dynComponent.items as IFieldGridData[];
      this.fieldStore.changeSelectedField([]);
      this.fieldStore.zoomFarmFields();
    }
    this._createStatistic(itemsToSelect);
  }

  private _onMerge(mergeResult: string): void {
    if (mergeResult != null && this.dynComponent != null) {
      const mergeResultJSON = JSON.parse(mergeResult);
      if (mergeResultJSON.type !== 'Polygon') {
        const message = {
          DisplayTimeout: 10,
          Level: Data.Api.Validation.ApValidationLevel.Warning,
          ErrorKey: 'Field__Merge_Error_Distance'
        } as IApValidationResult;
        this.notifyStore.addMessage(message);
        return;
      }
      this.fieldService.ShowMapGoIn();
      const gridSelectedKeys = this.fieldStore.getSelectedFieldIds();
      const emptyRecord: IFieldGridData = this.fieldGridDataFactory.CreateNew(
        this.fieldFactory.CreateNew({
          FieldName: this.translationStore.FindTranslationForSelectedLanguage(MergeNewFieldName),
          FieldNumber: '0',
          FieldSubnumber: '0'
        }),
        {Id: -1}
      );
      this.formStore.openForm({
        component: ApMergeFieldComponent, data: {
          CurrentItem: this.dynComponent.getSelectedItems()[0],
          AllItems: this.dynComponent.getSelectedItems().concat(emptyRecord),
          gridSelectedKeys,
        }
      });

      this.mapStore.Editor.ClearMergeFieldResult();
      const geomIds: IGuid[] = (this.dynComponent.getSelectedItems() as IFieldGridData[]).map(value => value.Geom.Id);
      this.fieldStore.fieldsToIgnoreInSnap = [geomIds[1].toString()];
      this.fieldStore.editFields([geomIds[0]]);
      this.mapStore.Editor.PrepareModifyMergedField(geomIds, mergeResultJSON.coordinates, this.fieldStore);
    }
  }

  private _onFiledStoreSaved(saved: boolean): void {
    if (saved) {
      setTimeout(() => this.mapStore.Layers.PolygonEditLayer.clearSelection(), 1);
      this.mapStore.Layers.PolygonEditLayer.clear();
      this.formStore.closeForm();
    }
  }

  private _fieldCropSaved(saved: boolean | undefined): void {
    if (saved === undefined) {
      return;
    }
    if (saved) {
      this.notifyStore.showSaveSuccessMessage();
    } else {
      this.notifyStore.showSaveFailMessage();
    }
  }

  private _onDownloadPackageId(packageId: IGuid): void {
    MapFactoryRequestor.getPackage(packageId).then(d => {
      download(d, `${packageId}.zip`, 'application/zip');
    }).catch(err => console.warn(`download of package ${packageId} fails`, err));
  }

  private _onSplit($event: any): void {
    if (!$event.SourceItem) {
      console.warn('No source item!');
      return;
    }
    const geom = this.fieldStore.getCurrentFieldGeom($event.SourceItem);
    const fieldOriginal = new SplitFieldData($event.SourceItem.FieldName, $event.SourceItem.FieldNumber, $event.SourceItem.FieldSubnumber);
    fieldOriginal.Id = $event.SourceItem.Id;
    fieldOriginal.MainCrop = $event.CropData?.CroptypeId;
    fieldOriginal.MainCropYieldUnit = $event.CropData?.ExpectedYield;
    fieldOriginal.SecondCrop = $event.CropData?.CroptypeSecondId;
    fieldOriginal.SecondCropYieldUnit = $event.CropData?.ExpectedYieldSecond;
    fieldOriginal.RemoveResidues = $event.CropData?.StrawHarvested ?? false;
    fieldOriginal.Note = $event.CropData?.Note;
    fieldOriginal.GridSize = $event.SourceItem.GridSize;

    this.formStore.openForm({
      component: ApSplitFieldComponent, data: {
        OldField: fieldOriginal,
        FieldOne: new SplitFieldData($event.SourceItem.FieldName, $event.SourceItem.FieldNumber, $event.SourceItem.FieldSubnumber),
        FieldTwo: new SplitFieldData($event.SourceItem.FieldName, $event.SourceItem.FieldNumber, $event.SourceItem.FieldSubnumber)
      }
    });
    this.mapStore.Editor.PrepareSplitField(geom.Id, this.fieldStore);
  }

  public onEdit($event: any): void {
    const geom = this.fieldStore.getCurrentFieldGeom($event.SourceItem);
    if (!$event.SourceItem || !geom) {
      console.warn(`no source item or default geom`);
      return;
    }
    this.fieldService.ShowMapGoIn();
    const gridSelectedKeys = this.fieldStore.getSelectedFieldIds();
    this.formStore.openForm({
      component: ApEditFieldComponent, data: {
        SourceItem: $event.SourceItem,
        gridSelectedKeys,
      }
    });
    this.fieldStore.editFields([geom.Id]);
    this.fieldStore.changeSelectedField([$event.SourceItem.Id]);
    this.mapStore.Editor.PrepareOpenEditBar();
  }

  public onCreate(): void {
    this.fieldService.OpenCreateForm();
  }

  private _gridBuilder(): void {
    this.columns$ =
      combineLatest([
        this.permissionPipe.transform(ApPermissions.EDIT_FIELDS),
        this.loginStore.User$,
        this.languageStore.SelectedLanguage$,
      ]).pipe(map(([permission, user, language]) => [
        new ApDynGridStatusColumnConfig({
          field: 'Status',
          showHeaderTitle: false,
          class: 'StatusClass',
          description: 'StatusDesc',
          pending: this.jobStore.BlockedFieldIdsBuWsvCeIrRbFieldRaster$,
          pendingTooltip: this.jobStore.BlockedFieldIdsBuWsvCeIrRbFieldRasterTooltip$,
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__NumberAbbr',
          field: 'SourceItem.FieldNumber',
          filterable: true,
          hide: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true,
          width: 40
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__FieldPartShort',
          field: 'SourceItem.FieldSubnumber',
          filterable: true,
          hide: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true,
          width: 40
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__NumberAbbr',
          field: 'NrSNr',
          filterable: true,
          hide: new ApDynGridColumnHideConfig({
            mapHide: false,
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
          }),
          width: 75,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__FieldName',
          field: 'SourceItem.FieldName',
          filterable: true,
          headerFilterable: true,
          sortIndex: 0,
          sortDesc: false,
          width: 120,
          cssClass: 'left'
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Area_Unit',
          field: 'Area',
          headerFilterable: true,
          width: 60,
          tooltip: (dataItem) => dataItem['AreaOriginal'],
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [this.settingsStore.FirstSetting.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridGroupColumnConfig({
          title: 'MainCrop',
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: 'MainCrop',
              field: 'MainCrop',
              filterable: true,
              headerFilterable: true,
              width: 100
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'MainCropExpectedYield',
              title: 'Global__YieldUnit',
              headerFilterable: true,
              width: 60,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              hide: true,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [
                  this.settingsStore.FirstSetting.DigitsAfterDecimalPoint,
                  GetRoundNumericPipeConfig.NullAndZeroToEmptyReplaceConfig
                ]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'StrawHarvested',
              title: 'Nutrients_Pages__StrawRemoved',
              hide: true,
              checkbox: true,
              width: 40
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'Note',
              title: 'Global__Fieldcrop_Notes',
              tooltip: (dataItem) => this.tooltipContentService.generateCropNoteTooltip(dataItem['Note']),
              width: 120
            })
          ]
        }),
        new ApDynGridGroupColumnConfig({
          title: 'SecondCrop',
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: 'SecondCrop',
              field: 'SecondCrop',
              filterable: true,
              headerFilterable: true,
              width: 100
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'SecondCropExpectedYield',
              title: 'Global__YieldUnit',
              hide: true,
              headerFilterable: true,
              width: 60,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [this.settingsStore.FirstSetting.DigitsAfterDecimalPoint, {ToReplace: [''], ReplaceWith: ''}]
              }]
            })
          ]
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Soilgroups',
          title: 'Nutrients_Pages__SoilGroup',
          filterable: true,
          hide: true,
          headerFilterable: true,
          width: 80,
          cssClass: 'right',
          filterType: FilterType.NUMBER
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__FieldGeom_Creation_Date',
          field: 'Creation',
          format: `${language.DateFormat} HH:mm`,
          width: 80,
          hide: true
        }),
        new ApDynGridEditColumnConfig({
            data: (() => {
              const options = [
                {
                  text: 'Global__Edit',
                  callback: this._onEditEvent,
                  disabled: () => !this.campaignYearStore.IsHighestCampaignYear
                },
                {
                  text: 'Global__Delete',
                  classList: 'delete',
                  callback: this._onDeleteEvent,
                  disabled: () => !this.campaignYearStore.IsHighestCampaignYear
                },
                {
                  text: 'Global__Split',
                  callback: this._onSplitEvent,
                  disabled: () => !this.campaignYearStore.IsHighestCampaignYear
                }
              ];

              if (ApRoleTypeService.hasAgriconRole(user)) {
                options.Add({
                  text: 'Global__Download',
                  callback: this._onDownloadPackageEvent,
                  disabled: () => false
                });
              }
              return options;
            })(),
            disabled: !permission,
          }
        )
      ]));

    this.pager$ = this.permissionPipe.transform(ApPermissions.EDIT_FIELDS).pipe(
      map((permission) => new ApDynGridPagerConfig({
        listMassEditing: this._fillWizardChoiceData(),
        apply: this._applyClickedEvent,
        hasPermission: permission,
        preselect: false
      })));
  }

  private _fillWizardChoiceData(): IDynGridWizardChoiceData[] | Observable<IDynGridWizardChoiceData[]> {
    return combineLatest([
      this.cropTypeStore.Listen(s => s.data).asObservable(),
      this.campaignYearStore.Listen(s => s.selectedYear)
    ]).pipe(map(([crops]) => {
      const result = [
        {
          id: FieldMassEditAction.EditMainCrop,
          type: ApGridPagerType.None,
          name: this.translationStore.FindTranslationForSelectedLanguage('MainCrop'),
          onSubmit: this._applyClickedEvent,
          onChoiceSelect: ApUtilService.createEventEmitter(() => {
            const value = this._mainCropId$.getValue();
            this._mainCropId$.next(undefined);
            this._mainCropId$.next(value);
          }, this._subscriptions),
          formConfig: [
            new ApDynformsConfigFieldset({
              key: 'MainCropFieldSet',
              config: [
                new ApDynformsConfigComboBox({
                  key: 'MainCrop',
                  valueField: 'Id',
                  textField: 'Description',
                  valuePrimitive: true,
                  label: 'MainCrop',
                  options: this._mainCropId$.pipe(
                    map((id) => crops.filter((c) => c.Selected || c.Id === id))
                  ),
                  validators: [
                    new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
                  ],
                  value: this._mainCropId$.getValue(),
                  value$: this._mainCropId$,
                  itemTemplate: this.comboBoxCropTypeItem,
                }),
                new ApDynformsConfigNumerictextbox({
                  key: 'MainCrop_YieldUnit',
                  label: 'Global__YieldUnit',
                  min: 0,
                  validators: [
                    new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
                  ],
                  value$: this._mainCropMassEditChanged$.pipe(map((cropValueChange) => {
                    const originalCropFromSelectedFields = this._mainCropId$.getValue(); // undefined if they have different crops
                    if (!cropValueChange?.PreviousValue && cropValueChange && cropValueChange.CurrentValue && cropValueChange.CurrentValue === originalCropFromSelectedFields) {
                      const mainCrops = this.dynComponent.getSelectedItems()?.map((item) => ObjectFactory.Get(item, 'SourceItem.FieldCrops.0') as IFieldCrop);
                      if (mainCrops.length !== 0 && mainCrops.every((c) => c?.ExpectedYield === mainCrops[0].ExpectedYield)) {
                        return mainCrops[0].ExpectedYield;
                      }
                      return undefined;
                    } else {
                      return this.cropTypeStore.CropTypes.Find(c => c?.Id === cropValueChange?.CurrentValue)?.ExpectedYield;
                    }
                  }))
                }),
                new ApDynformsConfigCheckbox({
                  key: 'RemoveResidues',
                  label: 'Nutrients_Pages_Popups__RemoveResidues',
                  value$: this.dynComponent.SelectedItems$.pipe(map((items) => {
                    const mainCrops = items.map((item) => ObjectFactory.Get(item, 'SourceItem.FieldCrops.0') as IFieldCrop);
                    if (mainCrops.length !== 0 && mainCrops.every((v, _, a) =>
                      !!v && !!a[0] && v.StrawHarvested === a[0].StrawHarvested)) {
                      return mainCrops[0].StrawHarvested;
                    }
                    return undefined;
                  }))
                }),
                new ApDynformsConfigPlaceholder(),
              ]
            })
          ]
        } as IDynGridWizardChoiceData,
        {
          id: FieldMassEditAction.ResetMainCrop,
          type: ApGridPagerType.None,
          name: this.translationStore.FindTranslationForSelectedLanguage('CropRotation__MainCrop_remove'), // 'Global__Reset_MainCrop'),
          onSubmit: this._applyClickedEvent,
        } as IDynGridWizardChoiceData,
        {
          id: FieldMassEditAction.EditSecondCrop,
          type: ApGridPagerType.None,
          name: this.translationStore.FindTranslationForSelectedLanguage('SecondCrop'),
          onSubmit: this._applyClickedEvent,
          onChoiceSelect: ApUtilService.createEventEmitter(() => {
            const value = this._secondCropId$.getValue();
            this._secondCropId$.next(undefined);
            this._secondCropId$.next(value);
          }, this._subscriptions),
          formConfig: [
            new ApDynformsConfigFieldset({
              key: 'SecondCropFieldSet',
              config: [
                new ApDynformsConfigComboBox({
                  key: 'SecondCrop',
                  valueField: 'Id',
                  textField: 'Description',
                  valuePrimitive: true,
                  label: 'SecondCrop',
                  options: this._secondCropId$.pipe(
                    map((id) => crops.filter((c) => c.Selected || c.Id === id))
                  ),
                  validators: [
                    new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
                  ],
                  value$: this._secondCropId$,
                  itemTemplate: this.comboBoxCropTypeItem,
                }),
                new ApDynformsConfigNumerictextbox({
                  key: 'SecondCrop_YieldUnit',
                  label: 'Global__Yield_Removal_Unit',
                  min: 0,
                  validators: [
                    new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
                  ],
                  value$: this._secondCropMassEditChanged$.pipe(map((cropValueChange) => {
                    const originalCropFromSelectedFields = this._secondCropId$.getValue(); // undefined if they have different crops
                    if (!cropValueChange?.PreviousValue && cropValueChange && cropValueChange.CurrentValue && cropValueChange.CurrentValue === originalCropFromSelectedFields) {
                      const mainCrops = this.dynComponent.getSelectedItems()?.map((item) => ObjectFactory.Get(item, 'SourceItem.FieldCrops.0') as IFieldCrop);
                      if (mainCrops.length !== 0 && mainCrops.every((c) => c?.ExpectedYieldSecond === mainCrops[0].ExpectedYieldSecond)) {
                        return mainCrops[0].ExpectedYieldSecond;
                      }
                      return undefined;
                    } else {
                      // if we have valid croptype => default is 0 for second croptype
                      return this.cropTypeStore.CropTypes.Find(c => c?.Id === cropValueChange?.CurrentValue)?.Id > 0 ? 0 : undefined;
                    }
                  }))
                }),
              ]
            })
          ]
        } as IDynGridWizardChoiceData,
        {
          id: FieldMassEditAction.ResetSecondCrop,
          type: ApGridPagerType.None,
          name: this.translationStore.FindTranslationForSelectedLanguage('CropRotation__SecondCrop_remove'),
          onSubmit: this._applyClickedEvent,
        } as IDynGridWizardChoiceData,
        {
          id: FieldMassEditAction.UpdateCropNote,
          name: this.translationStore.FindTranslationForSelectedLanguage('Global__Fieldcrop_Notes'),
          type: ApGridPagerType.Text,
          values: null,
          onSubmit: this._applyClickedEvent
        } as IDynGridWizardChoiceData,
        {
          id: FieldMassEditAction.DeleteFields,
          name: this.translationStore.FindTranslationForSelectedLanguage('Base__MapMenuItemEdit_DeleteToolTip'),
          type: ApGridPagerType.None,
          values: null,
          onSubmit: this._applyClickedEvent
        } as IDynGridWizardChoiceData
      ];

      if (this.campaignYearStore.IsHighestCampaignYear) {
        result.push({
          id: FieldMassEditAction.MergeFields,
          type: ApGridPagerType.None,
          name: 'Field__Merge',
          onSubmit: this._applyClickedEvent
        } as IDynGridWizardChoiceData);
      }

      return result;
    }));
  }

  private _createStatistic(selectedItems: IFieldGridData[]): void {
    const totalItems = this.dynComponent.items as IFieldGridData[];
    const dataForTitles = totalItems.map(x => ({
      AreaHa: x.Area,
      Selected: selectedItems.some(z => z.Id === x.Id)
    }));
    const title = this.statisticService.generateFieldsAreaTitle(dataForTitles);
    this.statisticStore.setStatisticData(
      this.cropStatistic.gatherFieldCropsChartData(selectedItems.map(x => x.SourceItem)),
      ApStatsType.MainSecondCrop, title, ''
    );
    this.statisticStore.addSelection([{
      text: this.campaignYearStore.SelectedCampaignYear.Year.toString(),
      value: this.campaignYearStore.SelectedCampaignYear.Year
    }]);
    this.statisticStore.selectFromSelection(this.campaignYearStore.SelectedCampaignYear.Year);
  }

  private _onApplyClicked(event: IGridPagerData): void {
    if (!event.object) {
      this.notifyStore.addMessage({
        Level: ApValidationLevel.Warning,
        Counter: 1,
        ErrorKey: 'Something went wrong',
        UserId: null,
        UserName: null,
        DisplayTimeout: 3,
        Parameters: null
      });
      return;
    }

    const fieldsAmount = this.dynComponent.getSelectedItems().length;
    if (fieldsAmount > 10) {
      this._massEditPagerData = event;
      this.modalDialogStore.setModalDialogData(this.modalDialogPresets.ExistRelatedDataDialog(
        {
          confirmKey: 'confirmMassEdit',
          message: this.translationStore.FindTranslationForSelectedLanguage('Global_Message_Edit_Fields_Number', [fieldsAmount.toString()])
        }));
    } else {
      this.applyMassEditAction(event);
    }
  }

  private applyMassEditAction(event: IGridPagerData): void {
    const availableCroptypes = this.cropTypeStore.Listen((s) => s.data).getValue();

    switch (event.object.id) {
      case FieldMassEditAction.EditMainCrop: { // Hauptfrucht aktualisieren
        const fields = this.dynComponent.getSelectedItems().map((item) => item['SourceItem'] as IField);
        this.fieldStore.saveField(ObjectFactory.Copy(fields).map((field) => {
          const geom = this.fieldStore.getCurrentFieldGeom(field);
          const crop = field.FieldCrops.Find((c) => this.campaignYearStore.isSelectedCampaignYear(c));
          const cropType = availableCroptypes.Find((ct) => ct?.Id === this._currentMultiSelectFormValue['MainCrop']);
          let expectedYield = this._currentMultiSelectFormValue['MainCrop_YieldUnit'];
          // if a customer has not changed value => use old value,
          // the value is not set because the selected fields have different expected yields
          if (expectedYield === this.ValueNotSet) {
            expectedYield = crop ? crop.ExpectedYield : null;
          }
          if (crop) {
            crop.CroptypeId = cropType ? cropType.Id : null;
            crop.Cropkey = cropType ? cropType.CropKey : null;
            crop.ExpectedYield = expectedYield; // cropType ? this.currentMultiSelectFormValue['MainCrop_YieldUnit'] : null;
            crop.StrawHarvested = this._currentMultiSelectFormValue['RemoveResidues'];
          } else {
            field.FieldCrops.push({
              FieldId: field.Id,
              AdminArea: Create(geom?.AdminArea, 0),
              AreaHa: Create(geom?.AreaHa, 0),
              CroptypeId: cropType ? cropType.Id : null,
              Cropkey: cropType ? cropType.CropKey : null,
              ExpectedYield: expectedYield, // cropType ? this.currentMultiSelectFormValue['MainCrop_YieldUnit'] : null,
              StrawHarvested: this._currentMultiSelectFormValue['RemoveResidues'],
              FarmId: field.FarmId,
            } as unknown as IFieldCrop);
          }
          return field;
        }), this.campaignYearStore.SelectedCampaignYear.DefaultStart, this.campaignYearStore.SelectedCampaignYear.DefaultEnd);
        break;
      }
      case FieldMassEditAction.EditSecondCrop: { // Nebenfrucht aktualisieren
        const cropTypeSecond = availableCroptypes.Find((ct) => ct?.Id === this._currentMultiSelectFormValue['SecondCrop']);
        const fields = this.dynComponent.getSelectedItems().map((item) => item['SourceItem'] as IField);
        this.fieldStore.saveField(ObjectFactory.Copy(fields).map((field) => {
          const geom = this.fieldStore.getCurrentFieldGeom(field);
          const crop = field.FieldCrops.Find((c) => this.campaignYearStore.isSelectedCampaignYear(c));
          if (crop) {
            crop.CroptypeSecondId = cropTypeSecond ? cropTypeSecond.Id : null;
            crop.ExpectedYieldSecond = cropTypeSecond ? this._currentMultiSelectFormValue['SecondCrop_YieldUnit'] : null;
            crop.MainSecondCropType = cropTypeSecond ? cropTypeSecond.CropKey : null;
          } else {
            field.FieldCrops.push({
              FieldId: field.Id,
              AdminArea: Create(geom?.AdminArea, 0),
              AreaHa: Create(geom?.AreaHa, 0),
              CroptypeSecondId: cropTypeSecond ? cropTypeSecond.Id : null,
              MainSecondCropType: cropTypeSecond ? cropTypeSecond.CropKey : null,
              ExpectedYieldSecond: cropTypeSecond ? this._currentMultiSelectFormValue['SecondCrop_YieldUnit'] : null,
              StrawHarvested: this._currentMultiSelectFormValue['RemoveResidues'],
              FarmId: field.FarmId,
            } as unknown as IFieldCrop);
          }
          return field;
        }), this.campaignYearStore.SelectedCampaignYear.DefaultStart, this.campaignYearStore.SelectedCampaignYear.DefaultEnd);
        break;
      }
      case FieldMassEditAction.ResetMainCrop: {
        const fields = this.dynComponent.getSelectedItems().map((item) => item['SourceItem'] as IField);
        this.fieldStore.saveField(ObjectFactory.Copy(fields).map((field) => {
          const crop = field.FieldCrops.Find((c) => this.campaignYearStore.isSelectedCampaignYear(c));
          if (crop) {
            crop.CroptypeId = null;
            crop.Cropkey = null;
            crop.ExpectedYield = null;
          }
          return field;
        }), this.campaignYearStore.SelectedCampaignYear.DefaultStart, this.campaignYearStore.SelectedCampaignYear.DefaultEnd);
        break;
      }
      case FieldMassEditAction.ResetSecondCrop: {
        const fields = this.dynComponent.getSelectedItems().map((item) => item['SourceItem'] as IField);
        this.fieldStore.saveField(ObjectFactory.Copy(fields).map((field) => {
          const crop = field.FieldCrops.Find((c) => this.campaignYearStore.isSelectedCampaignYear(c));
          if (crop) {
            crop.CroptypeSecondId = null;
            crop.MainSecondCropType = null;
            crop.ExpectedYieldSecond = null;
          }
          return field;
        }), this.campaignYearStore.SelectedCampaignYear.DefaultStart, this.campaignYearStore.SelectedCampaignYear.DefaultEnd);
        break;
      }
      case FieldMassEditAction.MergeFields: {
        if (this.dynComponent.getSelectedItems().length !== 2) {
          const message = {
            DisplayTimeout: 10,
            Level: Data.Api.Validation.ApValidationLevel.Warning,
            ErrorKey: 'Field__Error_Two_Fields'
          } as IApValidationResult;
          this.notifyStore.addMessage(message);
          break;
        }
        this.mapStore.Editor.MergeFieldGeometries(
          (this.dynComponent.getSelectedItems()[0] as IFieldGridData).Geom.Id,
          (this.dynComponent.getSelectedItems()[1] as IFieldGridData).Geom.Id
        );
        break;
      }
      case FieldMassEditAction.UpdateCropNote: {
        const selectedItems = this.dynComponent.getSelectedItems() as IFieldGridData[];
        if (!selectedItems) {
          return;
        }
        const copiedFieldCrops = selectedItems.filter(x => x.MainCrop)
          .map(item => ObjectFactory.Copy(this.getCropService.getFieldCrop(item.SourceItem)));
        if (!copiedFieldCrops || copiedFieldCrops.length <= 0) {
          return;
        }
        copiedFieldCrops.forEach(filedCrop => {
          filedCrop.Note = event.value;
        });
        this.fieldStore.saveFieldCrops(copiedFieldCrops);
        break;
      }
      case FieldMassEditAction.DeleteFields: {
        const selectedItems = this.dynComponent.getSelectedItems() as IFieldGridData[];
        if (!selectedItems) {
          return;
        }
        this._openDeleteDialog(selectedItems);
        break;
      }
      default:
        this._updateParameter(event);
        break;
    }
  }

  private _updateParameter(event: any): void {
    const definition = this.parameterDefinitionStore.getParameterDefinitionById(event.object.id);
    const ids = this.dynComponent.getSelectedItems().map((item) => item.Id);
    const parameterValues = ids.map((id) => {
      const result = {
        RefId: id,
        DefinitionId: definition.Id,
        FarmId: this.loginStore.SelectedFarm.Id,
        ValidFrom: new Date(this.campaignYearStore.getDefaultStart(event.form.Date.getFullYear())),
        Valid: true,
      } as IParameterValue;
      switch (definition.TypeId) {
        case ParameterType.Boolean:
          result.ValueBoolean = event.form.Value === 1;
          break;
        case ParameterType.List:
          result.ValueListKey = event.form.Value;
          break;
        case ParameterType.Number:
          result.ValueNumber = event.form.Value;
          break;
        case ParameterType.Text:
          result.ValueString = event.form.Value;
          break;
        case ParameterType.TimeStamp:
          result.ValueTimestamp = event.form.Value;
          break;
      }
      result.ValidFrom = new Date(this.campaignYearStore.getDefaultStart(event.form.Date.getFullYear()));
      return result;
    });

    this.parameterValueStore.updateParameterValues(parameterValues);
  }

  private _openDeleteDialog(selectedItems: IFieldGridData[]): void {
    this._deleteFieldIds = selectedItems.map(x => x.Id);
    let message = 'Global_Message_Delete_Field';
    if (selectedItems.length > 1) {
      const fieldList = '\n\n' +
        selectedItems.slice(0, 10).map(x => `${x.SourceItem.FieldNumber} ${x.SourceItem.FieldSubnumber} ${x.SourceItem.FieldName}`).join('\n') +
        (selectedItems.length > 10 ? '\n...' : '');
      message = this.translationStore.FindTranslationForSelectedLanguage('Global_Message_Delete_Fields_Number', [selectedItems.length.toString()]) + fieldList;
    }
    this.modalDialogStore.setModalDialogData(this.modalDialogPresets.DeleteDialog(
      {title: 'Global__DeleteField', message}));
  }

  private _modalDialogOkClicked(result: IModalDialogResult): void {
    if (result?.key === 'confirmFieldOverview') {
      this.fieldStore.deleteFields(this._deleteFieldIds);
    } else if (result?.key === 'delete') {
      this.fieldStore.clearFieldRelatedDataResult();
      this._checkForRelatedDataOnDelete = true;
      this.fieldStore.checkFieldsRelatedData(this._deleteFieldIds);
    } else if (result?.key === 'confirmMassEdit') {
      this.applyMassEditAction(this._massEditPagerData);
    }
  }
}
